import { serverInstance } from '@/shared/axios';
import { HelpCenterCategoryList } from '@/types/help';
import { BaseResponse } from '@/types/web.interface';

// 获取帮助中心分类列表
export async function getHelpCenterCategoryList() {
  const res = await serverInstance.get<BaseResponse<HelpCenterCategoryList>>(`/how-to/classify/list`);
  return res.data;
}
